import OT from "@opentok/client";

export default {
  /** Create OT publisher */
  createDefaultPublisher({ commit, dispatch, getters, rootState }, { ref }) {
    let publisher = OT.initPublisher(ref, getters.publisherConfig, err => {
      // eslint-disable-next-line no-console
      if (err) console.error(err);
      commit("setDefaultPublisher", publisher);
    });

    publisher.on("audioLevelUpdated", async event => {
      if (rootState.videoChat.activeVideoSession) {
        await dispatch("videoChat/updateVideoChatMemberAudioLevel", event, { root: true });
      }
    });

    publisher.on("streamDestroyed", async event => {
      // Prevent default behavior to re-use publisher for other calls
      event.preventDefault();
      // Dev note: there are currently bug in OT SDK (or docs), this marked as a solution
      // for reusing created publisher, but currently stream channels are not removed and
      // stack with every call. Need to keep it in eye.
    });
  },
  /** Publish default publisher to session */
  publishToSession({ state }, { session }) {
    if (session && session.isConnected()) {
      session.publish(state.defaultPublisher, err => {
        // eslint-disable-next-line no-console
        if (err) console.error(err);
      });
    }
  },
  /** Create OT subscriber */
  createSubscriber({ dispatch, commit, getters, rootState }, { stream, ref }) {
    const subscriber = rootState.videoChat.activeVideoSession.subscribe(stream, ref, getters.subscriberConfig, err => {
      // eslint-disable-next-line no-console
      if (err) console.error(err);
      subscriber.setAudioVolume(getters.subscriberConfig.audioVolume);
    });

    if (subscriber) {
      subscriber.on("audioLevelUpdated", async event => {
        await dispatch("videoChat/updateVideoChatMemberAudioLevel", event, { root: true });
      });

      commit("videoChat/addSubscriber", subscriber, { root: true });
    }
  },

  /** Set self audio status */
  setPublisherAudioEnabled({ state, commit }, isEnabled) {
    commit("setPublisherAudioEnabled", isEnabled);
    state.defaultPublisher.publishAudio(isEnabled);
  },
  /** Set self video status */
  setPublisherVideoEnabled({ state, commit }, isEnabled) {
    commit("setPublisherVideoEnabled", isEnabled);
    state.defaultPublisher.publishVideo(isEnabled);
  },

  /** Mute/unmute other users on a call */
  setSubscriberAudioEnabled({ commit, rootState }, isEnabled) {
    commit("setSubscriberAudioEnabled", isEnabled);
    rootState.videoChat.subscribers.forEach(subscriber => subscriber.subscribeToAudio(isEnabled));
  },
  /** Change volume for other users on a call */
  setSubscriberAudioLevel({ commit, rootState, dispatch, state }, level) {
    if (!level) {
      dispatch("setSubscriberAudioEnabled", false);
    } else {
      if (!state.subscriberAudioEnabled) dispatch("setSubscriberAudioEnabled", true);
      commit("setSubscriberAudioLevel", level);
      rootState.videoChat.subscribers.forEach(subscriber => subscriber.setAudioVolume(level));
    }
  }
};
